import React from 'react'
import Deal_1 from '../../../assets/images/home_page_2/deals/01.png'
import Deal_2 from '../../../assets/images/home_page_2/deals/bg-img.png'
import { Link } from 'react-router-dom'

const Deals = () => {
    return (
        <>
            <section id="deals" className="deals-main-block">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-6">
                            <div className="section">
                                <h1 className="section-title cormorant-font">
                                    Deal of <br /> The Day
                                </h1>
                                <ul className="deal-time-price">
                                    <li>
                                        <div className="deal-line" />
                                    </li>
                                    <li>
                                        <div className="deal-time">05:01:05</div>
                                        <div className="deal-price">
                                            <span>From:</span> $30.00
                                        </div>
                                    </li>
                                </ul>
                                <Link to="#" className="btn btn-primary-second">
                                    Learn More <i className="flaticon-arrow-right" />
                                </Link>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                            <div className="deal-img-block">
                                <img
                                    src={Deal_1}
                                    className="img-fluid"
                                    alt=""
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="deals-bg-img">
                    <img
                        src={Deal_2}
                        className="img-fluid"
                        alt=""
                    />
                </div>
            </section>

        </>
    )
}

export default Deals
